import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  public loader: boolean = true;
  public opacity: number = 1;
  private interval: any;
  private fadeOut: boolean = true;

  constructor(private router: Router) {
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationStart) {
          this.loader = true;
          this.startLoader();
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError){
          this.loader = false;
          this.stopLoader();
        }
      },
      () => {
        this.loader = false;
        this.stopLoader();
      }
    )
  }

  ngOnInit(): void {
    this.startLoader();
  }

  ngOnDestroy(){
    this.loader = false;
    this.stopLoader();
  }

  startLoader() {
    this.stopLoader();
    this.opacity = 1;
    this.fadeOut = true;
    this.interval = setInterval(() => {
      if (this.fadeOut) {
        this.opacity = 0.6;
      } else {
        this.opacity = 1;
      }
      this.fadeOut = !this.fadeOut;
    }, 500); // Change opacity every 500ms
  }

  stopLoader() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.opacity = 1;
  }
}
